module.exports = __webpack_public_path__ + "img/Number=108.d8ec5cba.png";